import Modal from 'www/modules/Modal/index'

const targets = ['doctors', 'reviews', 'prices']

targets.forEach(target => {
  const modalId = `lpu-branches-list-${target}`

  if (document.querySelector(`[data-modal-template="${modalId}"]`)) {
    new Modal({
      id: modalId,
      render: 'html',
      catchEventShow: [`[data-lpu-branches-list-show-${target}]`],
      catchEventHide: [`[data-lpu-branches-list-hide-${target}]`],
    })
  }
})
